import {Theme} from "@mui/material";

/**
 * Single source of truth for v3 chart series colours. A series/slice palette is the org THEME colour first, then
 * this fixed categorical set — assigned in order (an API-provided `color` on a series/slice always overrides).
 * Keep every v3 chart on this so a category reads the same colour everywhere; edit the set here, once.
 */
export const CHART_COLORS = [
    "#5b8def", // blue
    "#34c3a3", // teal
    "#f2b134", // amber
    "#ef6f6c", // coral
    "#9b7ede", // violet
    "#4ea1d3", // sky
    "#f0876c", // salmon
    "#7bc86c", // green
    "#94a3b8", // slate
    "#e07a9b", // pink
];

/** The full series palette: the theme's primary colour first, then the fixed set. */
export const chartPalette = (theme: Theme): string[] => [theme.palette.primary.main, ...CHART_COLORS];
